import { useEffect, useRef } from 'react';
import KnowledgeBase from './KnowledgeBase';
import { Icon } from './Controls';

export default function KnowledgeModal({ open, onClose }) {
  const dialog = useRef(null);
  useEffect(() => {
    const element = dialog.current;
    if (open && !element.open) element.showModal();
    if (!open && element.open) element.close();
  }, [open]);
  return <dialog ref={dialog} className="arts-knowledge-modal text-ink" aria-labelledby="knowledge-title" onCancel={onClose} onClose={onClose} onClick={(event) => { if (event.target === dialog.current) { const bounds = dialog.current.getBoundingClientRect(); if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) onClose(); } }}>
    <header className="flex items-center justify-between px-6 py-5 border-b border-edge"><div><p className="text-xs text-ink-muted mb-1">HKU Arts</p><h2 id="knowledge-title" className="text-xl font-semibold">Knowledge base</h2></div><button type="button" className="arts-icon-button" aria-label="Close knowledge base" onClick={onClose}><Icon name="close" /></button></header>
    <div className="arts-knowledge-body">{open && <KnowledgeBase />}</div>
  </dialog>;
}
